import React, { useContext } from "react";
import format from "date-fns/format";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { BRAND_AIA } from "@config/siteConfig";
import { ApplicationContext } from "@context/ApplicationContext";
import PromoLogoAia from "@components/Icons/PromoLogoAia";
import TicketIcon from "@components/Icons/TicketIcon";
import { getSessionButtonText } from "@utils/ticketUtils";
import "./style.scss";

const SessionButton = ({ session, showPromoIcon = false }) => {
    const { whiteLabel } = useContext(ApplicationContext);


    return (
        <div className="session-btn__time-item">
            <Link
                key={session.id}
                className="button button__secondary session-btn__time-item"
                to={`/ticket/purchase/${session.id}`}
            >
                {showPromoIcon && (
                    whiteLabel?.brand_code === BRAND_AIA ? <PromoLogoAia className="session-btn__promo-img" /> : <TicketIcon className="session-btn__promo-img" />
                )}
                <span className="session-btn__time">{format(session.d, "h:mm a")}</span>
                <span className="session-btn__price">${(session.ticket_price_cents / 100).toFixed(2)}</span>
                <span className="session-btn__class">{getSessionButtonText(session)}</span>
            </Link>
        </div>
    );
};

SessionButton.propTypes = {
    session: PropTypes.shape({
        id: PropTypes.number,
        d: PropTypes.instanceOf(Date),
        ticket_price_cents: PropTypes.number,
    }),
};

export default SessionButton;
